import {LIMITED} from "@/constants/TypeUser";

export default {

    getMenu(loggedUser){
        const protocolMenuLimited = [
            {label: 'menu.protocol.budgets-list', icon: 'pi pi-fw pi-bars', group: 'protocol', routerName: 'budgetsList', to: '/budgets-list'},
            {label: 'menu.protocol.list', icon: 'pi pi-fw pi-bars', group: 'protocol', routerName: 'protocolList', to: '/protocol-list'},
        ];
        const protocolMenuFull = [...protocolMenuLimited, {label: 'menu.protocol.form', icon: 'pi pi-fw pi-file-o', group: 'protocol', routerName: 'protocolForm', to: '/protocol/form' }]
        return [
            {label: 'menu.dashboard', icon: 'pi pi-fw pi-home', routerName: 'dashboard', to: '/'},
            {
                label: 'menu.protocol.main', icon: 'pi pi-fw pi-file-o',
                group: 'protocol',
                items: loggedUser.typeUser === LIMITED
                        ? protocolMenuLimited
                        : protocolMenuFull
            },
            {
                label: 'menu.client.main', icon: 'pi pi-fw pi-users',
                group: 'client',
                items: [
                    {label: 'menu.client.form', icon: 'pi pi-fw pi-user-edit', group: 'client', routerName: 'client', to: '/client' },
                    {label: 'menu.client.list', icon: 'pi pi-fw pi-bars', group: 'client', routerName: 'clientList', to: '/client/list'}
                ]
            },
            {
                label: 'menu.reports.main', icon: 'pi pi-fw pi-chart-bar',
                group: 'reports',
                items: [
                    {label: 'menu.reports.protocol-control', icon: 'pi pi-fw pi-chart-bar', group: 'reports', routerName: 'protocolControlReport', to: '/reports/protocol-control'}
                ]
            },
        ];
    }

}
